// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  unitId: __t.u64().primaryKey().name("unit_id"),
  battleId: __t.u64().name("battle_id"),
  worldId: __t.u64().name("world_id"),
  versonaId: __t.u64().name("versona_id"),
  side: __t.string(),
  role: __t.string(),
  weaponKey: __t.string().name("weapon_key"),
  hp: __t.i32(),
  morale: __t.i32(),
  state: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  targetId: __t.u64().name("target_id"),
  lastHit: __t.i32().name("last_hit"),
  updatedAt: __t.timestamp().name("updated_at"),
});
